import {Location} from 'react-router-dom'

const getEmailFromURLParams = (location: Location): string | null => {
  const email = new URLSearchParams(location.search).get('email')
  if (!email) return null
  return decodeURIComponent(email)
}

export default getEmailFromURLParams
